/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartNetwork = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M8 2a3 3 0 0 1 2.196 5.043l1.24 2.01a3.014 3.014 0 0 1 2.319.514l1.317-.913a3 3 0 1 1 1.065 1.697l-1.242.86a3.001 3.001 0 0 1-.175 2.056l2.997 3.02a3 3 0 1 1-1.42 1.41l-2.98-3.001A2.987 2.987 0 0 1 12 15a2.987 2.987 0 0 1-1.848-.637l-2.279 1.772a3 3 0 1 1-1.183-1.614l2.385-1.853a3.007 3.007 0 0 1 .634-2.604L8.418 7.97A3 3 0 1 1 8 2zm11 16a1 1 0 1 0 .001 2.001A1 1 0 0 0 19 18zM5 16a1 1 0 1 0 .001 2.001A1 1 0 0 0 5 16zm7-5a1 1 0 1 0 .001 2.001A1 1 0 0 0 12 11zm6-4a1 1 0 1 0 .001 2.001A1 1 0 0 0 18 7zM8 4a1 1 0 1 0 .001 2.001A1 1 0 0 0 8 4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartNetwork as ChartNetwork };
